export default "__VITE_ASSET__DBtAylTU__"